<script setup lang="ts">
type ReferenceItem = {
  label: string;
  time: string;
  muted?: boolean;
  done?: boolean;
};

defineProps<{
  items: ReferenceItem[];
}>();
</script>

<template>
  <div v-if="items.length" class="mt-4 sm:mt-6 px-4 sm:px-6 space-y-2">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="flex items-center justify-between text-sm sm:text-base py-2 sm:py-2.5 border-b border-gray-100 dark:border-gray-800 last:border-0"
      :class="
        item.muted
          ? 'text-gray-400 dark:text-gray-500'
          : 'text-gray-700 dark:text-gray-300'
      "
    >
      <span class="flex items-center gap-2">
        <UIcon
          v-if="item.done"
          name="i-heroicons-check-circle"
          class="w-4 h-4 sm:w-5 sm:h-5 text-green-500 dark:text-green-400"
        />
        <span :class="item.done ? 'line-through' : ''">
          {{ item.label }}
        </span>
      </span>

      <span class="font-semibold tabular-nums text-base sm:text-lg">
        {{ item.time }}
      </span>
    </div>
  </div>
</template>
